import $ from 'jquery';

let binds = [];

export const bindWindowEvent = (name, callback) => {
  $(window).off(name);
  $(window).on(name, callback);
  binds.push(name);
};

export const sendWindowEvent = (name, data = null) => {
  $(window).trigger(name, data);
};

export const destroyWindowEvents = () => {
  binds.forEach(bind => {
    $(window).off(bind);
  });
  binds = [];
};

